module.exports = __webpack_public_path__ + "img/sj05.153f8024.png";